export interface Item {
  selected?: boolean;
  item_id?: number;
  item_key?: string;
  company_id?: number;
  location_id?: number;
  user_id?: number;
  item_active?: number;
  item_date?: Date;
  form_id?: number;
  common_id?: number;
  product_id?: number;
  product_name?: string;
  inventory_id?: number;
  unit_id?: number;
  item_status_id?: number;
  item_status_name?: string;
  order_status_id?: number;
  order_status_name?: string;
  stock_status_id?: number;
  stock_status_name?: string;
  item_utncode?: string;
  item_skucode?: string;
  item_price?: number;
  item_quantity?: number;
  item_gross_amount?: number;
  item_discount_percentage?: number;
  item_discount_amount?: number;
  item_deposit_percentage?: number;
  item_deposit_amount?: number;
  item_taxable_amount?: number;
  item_tax1_percentage?: number;
  item_tax2_percentage?: number;
  item_tax3_percentage?: number;
  item_tax1_amount?: number;
  item_tax2_amount?: number;
  item_tax3_amount?: number;
  item_net_amount?: number;
  item_paid_amount?: number;
  item_comment?: string;
  item_history?: string;
}


export const emptyItem: Item = {
  selected: false,
  item_skucode: '',
  item_price: 0,
  item_quantity: 0,
  unit_id: 2,
  item_gross_amount: 0,
  item_discount_percentage: 0,
  item_discount_amount: 0,
  item_deposit_percentage: 0,
  item_deposit_amount: 0,
  item_taxable_amount: 0,
  item_tax1_percentage: 0,
  item_tax1_amount: 0,
  item_net_amount: 0,
  stock_status_id: 2,
  order_status_id: 2,
  item_status_id:2, 
};

export const itemKeys: (keyof Item)[] = [
  "item_id",
  "item_key",
  "company_id",
  "location_id",
  "user_id",
  "item_active",
  "item_date",
  "form_id",
  "common_id",
  "product_id",
  "inventory_id",
  "unit_id",
  "item_status_id",
  "order_status_id",
  "stock_status_id",
  "item_utncode",
  "item_skucode",
  "item_price",
  "item_quantity",
  "item_gross_amount",
  "item_discount_percentage",
  "item_discount_amount",
  "item_deposit_percentage",
  "item_deposit_amount",
  "item_taxable_amount",
  "item_tax1_percentage",
  "item_tax2_percentage",
  "item_tax3_percentage",
  "item_tax1_amount",
  "item_tax2_amount",
  "item_tax3_amount",
  "item_net_amount",
  "item_paid_amount",
  "item_comment",
  "item_history"
];
